import { AnnotationType, AnnotationTypes } from '@readcloud/data';
export type AnnotationRendererProps<Data, Type extends string> = {
  id: string;
  data: Data;
  height: number;
  width: number;
  dragging: boolean;
  editing: boolean;
  type: Type;
  scale: number;
  selected: boolean;
};

export const toolType = AnnotationTypes;

export type ToolType = AnnotationType | 'Select';

export const toolTypes: { [k in ToolType]: k } = {
  Circle: 'Circle',
  Rectangle: 'Rectangle',
  HTML: 'HTML',
  OverlayText: 'OverlayText',
  Image: 'Image',
  Media: 'Media',
  Path: 'Path',
  Select: 'Select',
  Text: 'Text',
};
